import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  OnDestroy,
  effect,
  inject,
  input,
  signal,
} from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { Guid } from 'guid-typescript';
import { SiaUsersService } from '../../services/users.service';

@Component({
  selector: 'sia-cell-avatar',
  templateUrl: './sia-cell-avatar.component.html',
  styleUrls: ['./sia-cell-avatar.component.css'],
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiaGridAvatarComponent implements OnDestroy {
  private userService = inject(SiaUsersService);

  private _empty = '../../../assets/skeleton/empty-avatar.png';

  readonly width = input<number>(64);
  readonly userId = input<number | undefined>(undefined);

  url = signal<SafeUrl | string | undefined>(undefined);

  guid: string;
  @HostListener('window:unload')
  ngOnDestroy() {
    this.url.set(undefined);
  }

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {
    this.guid = Guid.create().toString();

    effect(() => {
      const id = this.userId();

      if (!id || this.url()) {
        return;
      }

      this.userService.getUserAvatar(id).then((fetchedUrl: any) => {
        if (fetchedUrl) {
          this.url.set(fetchedUrl);
        } else {
          this.url.set(this._empty);
        }
      });
    });
  }
}
